export const HOT_UPDATE_GET_LIST = 'HOT_UPDATE_GET_LIST';
export const HOT_UPDATE_ENABLE = 'HOT_UPDATE_ENABLE';
export const HOT_UPDATE_GET_DETAIL_BY_ID = 'HOT_UPDATE_GET_DETAIL_BY_ID';
export const HOT_UPDATE_GET_VERSION_LIST = 'HOT_UPDATE_GET_VERSION_LIST';
export const HOT_UPDATE_ADD = 'HOT_UPDATE_ADD';